import styled from 'styled-components';

export const Fill = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const Corner = styled.div`
  position: absolute;
  width: 6px;
  height: 6px;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
`;

export const Horizontal = styled.div`
  position: absolute;
  width: calc(100% - 8px);
  height: 10px;
`;

export const Vertical = styled.div`
  position: absolute;
  height: calc(100% - 8px);
  width: 10px;
`;
